import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";

import { Button, TextField, Typography } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import { v4 as uuidv4 } from "uuid";
import { ErrorBoundary } from "./IntegrationEditor";

const google_map_key = "AIzaSyBUa_barzIuzeWqAGQdjiDjh44crJiX_xg";

export const defaultCss = {
  header: {
    fontSize: "24px",
    fontWeight: "bold",
    margin: "16px 0",
    color: "#333",
    fontFamily: "Arial, sans-serif",
    transition: "all 0.3s ease",
  },
  paragraph: {
    fontSize: "16px",
    margin: "12px 0",
    color: "#555",
    lineHeight: "1.5",
    fontFamily: "Arial, sans-serif",
    transition: "all 0.3s ease",
  },
  quote: {
    fontSize: "18px",
    fontStyle: "italic",
    margin: "16px 0",
    padding: "0 20px",
    borderLeft: "4px solid #1976d2",
    color: "#444",
    fontFamily: "Georgia, serif",
    transition: "all 0.3s ease",
  },
  button: {
    fontSize: "16px",
    padding: "8px 16px",
    backgroundColor: "#1976d2",
    color: "#fff",
    borderRadius: "4px",
    fontFamily: "Arial, sans-serif",
    textTransform: "uppercase",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
    transition: "all 0.3s ease",
    cursor: "pointer",
  },
  list: {
    fontSize: "16px",
    margin: "12px 0",
    paddingLeft: "20px",
    color: "#555",
    fontFamily: "Arial, sans-serif",
    transition: "all 0.3s ease",
  },
  image: {
    margin: "16px 0",
    borderRadius: "8px",
    maxWidth: "100%",
    width: "100%",
    height: "auto",
    objectFit: "cover",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease",
  },
  form: {
    margin: "16px 0",
    padding: "16px",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    border: "1px solid #dee2e6",
    fontFamily: "Arial, sans-serif",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease",
  },
  card: {
    margin: "16px 0",
    padding: "16px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    border: "1px solid #dee2e6",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    fontFamily: "Arial, sans-serif",
    transition: "all 0.3s ease",
  },
  map: {
    margin: "16px 0",
    borderRadius: "8px",
    height: "300px",
    width: "100%",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease",
  },
  table: {
    margin: "16px 0",
    borderCollapse: "collapse",
    width: "100%",
    fontFamily: "Arial, sans-serif",
    border: "1px solid #dee2e6",
    transition: "all 0.3s ease",
  },
  faq: {
    margin: "16px 0",
    padding: "8px 0",
    color: "#555",
    fontFamily: "Arial, sans-serif",
    transition: "all 0.3s ease",
  },
  displayName: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "0px",
    fontFamily: "Arial, sans-serif",
    transition: "all 0.3s ease",
  },
  displayNameContainer: {
    padding: "0",
    backgroundColor: "transparent",
    borderRadius: "4px",
    marginBottom: "8px",
    transition: "all 0.3s ease",
  },
  outer: {
    backgroundColor: "transparent",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    textAlign: "left",
  },
};

// export const ImageCarousel = React.memo(({ images = [], caption, css }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const goToPrev = useCallback(() => {
//     setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
//   }, [images]);

//   const goToNext = useCallback(() => {
//     setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
//   }, [images]);

//   if (!images.length) {
//     return <div style={{ color: '#718096' }}>No images to display</div>; // text-gray-600
//   }

//   return (
//     <div style={{ position: 'relative', width: '100%', margin: css?.margin || '0 0 16px 0' }}>
//       <div
//         style={{
//           position: 'relative',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           width: '100%',
//           // minHeight: '200px',
//         }}
//       >
//         {images[currentIndex]?.url &&

//         <img
//           src={images[currentIndex]?.url}
//           // src={imageUrl}
//           alt={`${caption || 'Image'} ${currentIndex + 1}`}
//           style={{
//             width: '100%',
//             height: 'auto',
//             objectFit: 'cover',
//             // maxHeight: '400px',
//             borderRadius: '8px',
//             ...css,
//           }}
//         />
//         }

//         {/* Previous Button */}
//         {images?.length && images.length>1 &&

//         <div
//           style={{
//             position: 'absolute',
//             left: '12px',
//             top: '50%',
//             transform: 'translateY(-50%)',
//             zIndex: 10,
//           }}
//         >
//           <Button
//             variant="contained"
//             color="secondary"
//             onClick={goToPrev}
//             disabled={images.length <= 1}
//           >
//             {'<'}
//           </Button>
//         </div>
//         }

//         {/* Next Button */}

//         {images?.length && images.length>1 &&

//         <div
//           style={{
//             position: 'absolute',
//             right: '12px',
//             top: '50%',
//             transform: 'translateY(-50%)',
//             zIndex: 10,
//           }}
//         >
//           <Button
//             variant="contained"
//             color="secondary"
//             onClick={goToNext}
//             disabled={images.length <= 1}
//           >
//             {'>'}
//           </Button>
//         </div>
//         }
//       </div>

//       {/* Pagination Dots */}
//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'center',
//           gap: '8px',
//           marginTop: '8px',
//         }}
//       >
//         {/* {images?.length>1 && images.map((_, index) => (
//           <span
//             key={index}
//             onClick={() => setCurrentIndex(index)}
//             style={{
//               width: '10px',
//               height: '10px',
//               borderRadius: '50%',
//               cursor: 'pointer',
//               backgroundColor: index === currentIndex ? '#2563EB' : '#A0AEC0', // blue-600 / gray-400
//             }}
//           />
//         ))} */}
//       </div>
//     </div>
//   );
// });

/* Vik (Sep 12, 2025): Added hover effect to ImageCarousel nav buttons */

const navBtnBase = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 10,
  height: 36,
  width: 36,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "2px solid rgba(255,255,255,0.95)", // white ring for any bg
  background: "rgba(0,0,0,0.35)", // dark semi-transparent fill
  boxShadow: "0 2px 8px rgba(0,0,0,0.5)", // lift
  backdropFilter: "blur(2px)", // glass effect
  WebkitBackdropFilter: "blur(2px)",
  color: "#fff",
  fontWeight: 800,
  lineHeight: 1,
  cursor: "pointer",
  userSelect: "none",
  WebkitTapHighlightColor: "transparent",
  transition:
    "transform .15s ease, box-shadow .15s ease, background .15s ease, border-color .15s ease",
  outline: "none",
};

// Hover delta applied on top of base styles
const navBtnHover = {
  transform: "translateY(-50%) scale(1.06)",
  background: "rgba(0,0,0,0.5)",
  boxShadow: "0 6px 16px rgba(0,0,0,0.6)",
  borderColor: "rgba(255,255,255,0.95)",
};

export const ImageCarousel = React.memo(
  ({
    images = [],
    caption,
    css,
    index = 0,
    fallbackText = "No images available",
  }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [imageStatus, setImageStatus] = useState({}); // Track load status and attempts
    const [hovered, setHovered] = useState({ prev: false, next: false });
    const maxRetries = 5; // Maximum number of retries per image
    const retryDelay = 2000; // Delay between retries in milliseconds (1 second)

    const goToPrev = useCallback(() => {
      setCurrentIndex((prev) => {
        let nextIndex = prev - 1;
        // Skip permanently failed images
        while (
          nextIndex >= 0 &&
          imageStatus[images[nextIndex]?.url]?.status === "failed"
        ) {
          nextIndex--;
        }
        return nextIndex < 0 ? images.length - 1 : nextIndex;
      });
    }, [images, imageStatus]);

    const goToNext = useCallback(() => {
      setCurrentIndex((prev) => {
        let nextIndex = prev + 1;
        // Skip permanently failed images
        while (
          nextIndex < images.length &&
          imageStatus[images[nextIndex]?.url]?.status === "failed"
        ) {
          nextIndex++;
        }
        return nextIndex >= images.length ? 0 : nextIndex;
      });
    }, [images, imageStatus]);

    // Preload images with retry logic
    useEffect(() => {
      const loadImage = async (url, attempt = 1) => {
        if (
          !url ||
          imageStatus[url]?.status === "loaded" ||
          imageStatus[url]?.status === "failed"
        ) {
          return; // Skip if already processed or permanently failed
        }

        const img = new Image();
        img.src = url;

        img.onload = () => {
          setImageStatus((prev) => ({
            ...prev,
            [url]: { status: "loaded", attempts: attempt },
          }));
        };

        img.onerror = () => {
          if (attempt < maxRetries) {
            // Schedule a retry after a delay
            setTimeout(() => {
              loadImage(url, attempt + 1);
            }, retryDelay * attempt); // Exponential backoff: 1x, 2x, 3x...
          } else {
            // Mark as permanently failed after max retries
            setImageStatus((prev) => ({
              ...prev,
              [url]: { status: "failed", attempts: attempt },
            }));
          }
        };
      };

      images.forEach((image) => loadImage(image.url));
    }, [images, imageStatus]);

    // Filter out permanently failed images and limit to 5 images
    const validImages = images
      .filter((image) => imageStatus[image.url]?.status !== "failed")
      .slice(0, 5); // Limit to first 5 images

    if (!validImages.length) {
      return (
        <div
          style={{
            color: "#718096",
            width: "96px",
            height: "96px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            fontSize: "14px",
            fontFamily: "'Arial', sans-serif",
          }}
        >
          {fallbackText}
        </div>
      );
    }

    return (
      <div
        style={{
          position: "relative",
          width: "100%",
          margin: css?.margin || "0 0 16px 0",
        }}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <img
            loading="lazy"
            src={
              validImages[currentIndex % validImages.length]?.url ||
              "https://via.placeholder.com/400?text=Image+Not+Available"
            }
            alt={`${caption || "Image"} ${currentIndex + 1}`}
            style={{
              width: "100%",
              height: "auto",
              objectFit: "cover",
              maxHeight: "400px",
              borderRadius: "8px",
              ...css,
            }}
            onError={(e) => {
              // Fallback to placeholder if image fails to load
              e.target.src =
                "https://via.placeholder.com/400?text=Image+Not+Available";
              const url = validImages[currentIndex % validImages.length]?.url;
              if (!(url && imageStatus[url]?.attempts < maxRetries)) {
                setImageStatus((prev) => ({
                  ...prev,
                  [url]: { status: "failed", attempts: maxRetries },
                }));
              }
            }}
          />

          {/* Hidden div for preloading images */}
          <div style={{ display: "none" }}>
            {images.map((image, idx) => (
              <img
                key={idx}
                src={image.url}
                alt=""
                loading="lazy"
                onError={() => {
                  if (imageStatus[image.url]?.attempts >= maxRetries) {
                    setImageStatus((prev) => ({
                      ...prev,
                      [image.url]: { status: "failed", attempts: maxRetries },
                    }));
                  }
                }}
                onLoad={() => {
                  setImageStatus((prev) => ({
                    ...prev,
                    [image.url]: {
                      status: "loaded",
                      attempts: imageStatus[image.url]?.attempts || 1,
                    },
                  }));
                }}
              />
            ))}
          </div>
        </div>

        {/* Previous Button */}
        {validImages.length > 1 && (
          <button
            type="button"
            aria-label="Previous image"
            onClick={goToPrev}
            disabled={validImages.length <= 1}
            onMouseEnter={() => setHovered((h) => ({ ...h, prev: true }))}
            onMouseLeave={() => setHovered((h) => ({ ...h, prev: false }))}
            style={{
              ...navBtnBase,
              left: 0,
              opacity: validImages.length <= 1 ? 0.5 : 1,
              pointerEvents: validImages.length <= 1 ? "none" : "auto",
              ...(hovered.prev ? navBtnHover : null),
            }}
          >
            <span style={{ textShadow: "0 0 2px #000, 0 0 2px #fff" }}>❮</span>
          </button>
        )}

        {/* Next Button */}
        {validImages.length > 1 && (
          <button
            type="button"
            aria-label="Next image"
            onClick={goToNext}
            disabled={validImages.length <= 1}
            onMouseEnter={() => setHovered((h) => ({ ...h, next: true }))}
            onMouseLeave={() => setHovered((h) => ({ ...h, next: false }))}
            style={{
              ...navBtnBase,
              right: 0,
              opacity: validImages.length <= 1 ? 0.5 : 1,
              pointerEvents: validImages.length <= 1 ? "none" : "auto",
              ...(hovered.next ? navBtnHover : null),
            }}
          >
            <span style={{ textShadow: "0 0 2px #000, 0 0 2px #fff" }}>❯</span>
          </button>
        )}
      </div>
    );
  }
);

export const MapBlockComponent = React.memo(({ lat, lng, css }) => {
  const [mapComponents, setMapComponents] = useState(null);

  useEffect(() => {
    import("@vis.gl/react-google-maps")
      .then(({ APIProvider, Map, Marker }) =>
        setMapComponents({ APIProvider, Map, Marker })
      )
      .catch((error) => console.error("Error loading Google Maps:", error));
  }, []);

  if (!mapComponents)
    return <div className="p-4 text-gray-600">Loading map...</div>;

  const { APIProvider, Map, Marker } = mapComponents;

  return (
    <div
      style={{
        width: "100%",
        height: "300px",
        borderRadius: "8px",
        overflow: "hidden",
        marginBottom: "16px",
        ...css,
      }}
    >
      <APIProvider apiKey={google_map_key}>
        <Map
          style={{ width: "100%", height: "100%" }}
          defaultCenter={{ lat, lng }}
          defaultZoom={15}
          gestureHandling={"greedy"}
          disableDefaultUI={true}
        >
          <Marker position={{ lat, lng }} />
        </Map>
      </APIProvider>
    </div>
  );
});

export const typeMatches = {
  header: ["heading", "header", "title"],
  paragraph: [
    "text",
    "paragraph",
    "description",
    "subtitle",
    "date",
    "time",
    "price",
  ],
  quote: ["quote", "note"],
  button: ["button", "link"],
  list: ["list"],
  image: ["image"],
  form: ["form", "signup", "quiz", "feedback", "catering", "contest"],
  // card: ['card', 'plan', 'carousel', 'blog', 'tracker', 'gift', 'delivery', 'social'],
  map: ["map"],
  table: ["table"],
  faq: ["faq"],
};

export const convertTypeMatches = (inputType) => {
  if (!inputType) return null;
  const normalizedInput = inputType.toLowerCase();
  for (const [blockType, aliases] of Object.entries(typeMatches)) {
    if (aliases.includes(normalizedInput) || blockType === normalizedInput)
      return blockType;
  }
  return null;
};

// export const CardPreview = React.memo(({ blocks }) => {
//   const cardStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     width: '100%',
//     minHeight: '100%',
//     backgroundColor: 'transparent',
//     borderRadius: '10px',
//     boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
//     // padding: '10px',
//     boxSizing: 'border-box',

//   };

//   const getElementValue = (block, field) => {
//     if (field==="display_name"){

//       return block?.data?.elements?.find((el) => el.field === field)?.value || block?.display_name;
//     }
//     return block.data?.elements?.find((el) => el.field === field)?.value || null;
//   };

//   const renderBlock = (
//     (block) => {
//       // console.log("🚀 ~ CardPreview ~ block:", block)
//       let outerCss = block?.outerCss
//       const blockType = convertTypeMatches(block?.display_type) || block.type;
//       const displayName = block.add_display_name ? getElementValue(block, 'display_name') || 'Unnamed Block' : null;
//       const isColumnLayout = ['image', 'map', 'form'].includes(blockType);

//       const blockContent = () => {
//         switch (blockType) {
//           case 'header':
//             return (
//               <h1 style={{ ...defaultCss?.header, ...block.css?.[blockType] }} className="text-2xl font-bold">
//                 {getElementValue(block, 'text') || block?.value}
//               </h1>
//             );
//           case 'paragraph':
//             return (
//               <p
//                 style={{ ...defaultCss.paragraph, ...block.css?.[blockType] }}
//                 className="text-gray-700"
//                 dangerouslySetInnerHTML={{ __html: getElementValue(block, 'text') || block?.value }}
//               />
//             );
//           case 'list':
//             return (
//               <ul style={{ ...defaultCss.list, ...block.css?.[blockType] }} className="list-disc pl-5">
//                 {(getElementValue(block, 'items') || []).map((item, i) => (
//                   <li key={i} className="text-gray-700">{item}</li>
//                 ))}
//               </ul>
//             );
//           case 'quote':
//             return (
//               <blockquote style={{ ...defaultCss.quote, ...block.css?.[blockType] }} className="border-l-4 border-gray-300 pl-4 italic text-gray-600">
//                 {getElementValue(block, 'text') || block?.value}
//               </blockquote>
//             );
//           case 'button':

//           const handleClick = () => {
//     window.open(getElementValue(block, 'url'), '_blank', 'noopener,noreferrer');
//   };
//             return (

//                 <Button variant="contained" style={{ ...defaultCss.button, ...block.css?.[blockType] }} onClick={handleClick} >
//                   {getElementValue(block, 'text') || block?.display_name}
//                 </Button>

//             );
//           case 'image':
//             let urls = getElementValue(block, 'files') || [];
//             if (!urls.length) {
//               const values = Array.isArray(block?.value) ? block.value : [block?.value];
//               urls = values.filter(Boolean).map((url) => ({ url }));
//             }
//             return <ImageCarousel images={urls} caption={getElementValue(block, 'caption')} css={{ ...defaultCss.image, ...block.css?.[blockType] }} />;
//           case 'form':
//             return (
//               <div style={{ ...defaultCss.form, ...block.css?.[blockType] }} className="space-y-4">
//                 <p className="font-bold">{getElementValue(block, 'title') || 'Form'}</p>
//                 {(getElementValue(block, 'fields') || []).map((field, i) => (
//                   <TextField
//                     key={i}
//                     label={field.label}
//                     name={field.name}
//                     type={field.field_type || 'text'}
//                     defaultValue={field.default_value || field.value}
//                     placeholder={field.placeholder}
//                     required={field.required || false}
//                     fullWidth
//                     margin="normal"
//                     className="bg-white"
//                   />
//                 ))}
//                 <Button variant="contained"  className="bg-blue-500 hover:bg-blue-700 text-white">
//                   {getElementValue(block, 'submitText') || 'Submit'}
//                 </Button>
//               </div>
//             );
//           // case 'card':
//           //   return (
//           //     <div style={{ ...defaultCss.card, ...block.css?.[blockType] }} className="p-4 bg-white rounded-lg shadow">
//           //       <h3 className="text-lg font-semibold">{getElementValue(block, 'title')}</h3>
//           //       <p className="text-gray-700">{getElementValue(block, 'description')}</p>
//           //     </div>
//           //   );
//           case 'map':
//             console.log("blockssssssssssssssssssssmap",block,getElementValue(block, 'lat'),getElementValue(block, 'lng'))
//             if(Number(getElementValue(block, 'lat')) &&getElementValue(block, 'lng') ){
//               let lat = Number(getElementValue(block, 'lat'));
//               let long= Number(getElementValue(block, 'lng'))
//               return <MapBlockComponent lat={lat} lng={long} css={{ ...defaultCss.map, ...block.css?.[blockType] }} />;
//             }else{
//               return null
//             }
//           case 'table':
//             return (
//               <div style={{overflow:"auto",width:"200px"}}>

//                 <table style={{ ...defaultCss.table, ...block.css?.[blockType] }} className=" border-collapse">
//                 <thead style={{overflow:"auto",width:"200px"}}>
//                   <tr>
//                     {(getElementValue(block, 'headers') || []).map((header, i) => (
//                       <th key={i} className="border border-gray-300 p-2 bg-gray-100">{header}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody style={{overflow:"auto",width:"200px"}}>
//                   {(getElementValue(block, 'rows') || []).map((row, i) => (
//                     <tr key={i}>
//                       {row.map((cell, j) => (
//                         <td key={j} className="border border-gray-300 p-2">{cell}</td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//               </div>
//             );
//           case 'faq':
//             return (
//               <div style={{ ...defaultCss.faq, ...block.css?.[blockType] }} className="space-y-2">
//                 {(getElementValue(block, 'items') || []).map((faqItem, i) => (
//                   <details key={i} className="bg-white p-3 rounded-lg shadow">
//                     <summary className="font-semibold cursor-pointer">{faqItem.question}</summary>
//                     <p className="text-gray-700 mt-2">{faqItem.answer}</p>
//                   </details>
//                 ))}
//               </div>
//             );
//           default:
//             // return <div style={block.css[blockType]} className="text-red-500">Unsupported block type: {block.type}</div>;
//             return null
//         }
//       };

//       return (
//         <div  style={{   display: 'flex', flexDirection: isColumnLayout ? 'column' : 'row', gap: '8px', }}>
//           {displayName && block.add_display_name ? (
//             isColumnLayout ? (
//               <div style={{ width: '100%',...outerCss }}>
//                 <div style={{ ...defaultCss.displayNameContainer, ...block.css.displayNameContainer }}>
//                   <Typography
//                     variant="subtitle1"
//                     style={{ p:0,m:0,...defaultCss.displayName, ...block.css.displayName }}
//                     className="font-bold text-gray-800"
//                   >
//                     {displayName}
//                   </Typography>
//                 </div>
//                 {blockContent()}
//               </div>
//             ) : (
//               <div className="flex flex-row items-center justify-start gap-1" style={{ width: '100%',...outerCss }}>
//                 <div style={{ ...defaultCss.displayNameContainer, ...block.css.displayNameContainer }}>
//                   <Typography
//                     variant="subtitle1"
//                     style={{ p:0,marginBlockEnd:0,...defaultCss.displayName, ...block.css.displayName }}
//                     className="font-bold text-gray-800 flex-shrink-0"
//                   >
//                     {displayName}:
//                   </Typography>
//                 </div>
//                 {blockContent()}
//               </div>
//             )
//           ) : (
//             <div style={{width:"100%",...outerCss}}>
//               {blockContent()}
//               </div>
//           )}
//         </div>
//       );
//     }

//   );

//   return (
//     <div className="card-preview-container " style={cardStyle}>
//       {blocks?.map((block) => (
//         <>
//         {
//           block?.isMerged ?

//           <>ss
//           <div key={block.id} className="card-block w-full relative" >
//           {renderBlock(block)}
//         </div>
//           {console.log("blockblock",block)}
//           </>

//           :

//         <div key={block.id} className="card-block w-full relative" >
//           {renderBlock(block)}
//         </div>
//         }
//         </>
//       ))}
//     </div>
//   );
// });

export const CardPreview = React.memo(({ blocks, parentCss = {} }) => {
  let cardStyle = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minHeight: "100%",
    backgroundColor: "transparent",
    borderRadius: "10px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    boxSizing: "border-box",
    ...parentCss,
  };

  const getElementValue = (block, field) => {
    if (field === "display_name") {
      return (
        block?.data?.elements?.find((el) => el?.field === field)?.value ||
        block?.display_name ||
        ""
      );
    }
    return (
      block?.data?.elements?.find((el) => el?.field === field)?.value || null
    );
  };

  const renderBlock = (block) => {
    if (!block) return null;

    const outerCss = block?.outerCss || {};
    const blockType = convertTypeMatches(block?.display_type) || block?.type;
    const displayName = block?.add_display_name
      ? getElementValue(block, "display_name") || "Unnamed Block"
      : null;
    const isColumnLayout = ["image", "map", "form"].includes(blockType);

    const blockContent = () => {
      switch (blockType) {
        case "header":
          return (
            <h1
              style={{ ...defaultCss?.header, ...block.css?.[blockType] }}
              className="text-2xl font-bold"
            >
              {getElementValue(block, "text") || block?.value}
            </h1>
          );
        case "paragraph":
          return (
            <p
              style={{ ...defaultCss?.paragraph, ...block.css?.[blockType] }}
              className="text-gray-700"
              dangerouslySetInnerHTML={{
                __html: getElementValue(block, "text") || block?.value,
              }}
            />
          );
        case "list":
          return (
            <ul
              style={{ ...defaultCss?.list, ...block.css?.[blockType] }}
              className="list-disc pl-5"
            >
              {(getElementValue(block, "items") || []).map((item, i) => (
                <li key={i} className="text-gray-700">
                  {item}
                </li>
              ))}
            </ul>
          );
        case "quote":
          return (
            <blockquote
              style={{ ...defaultCss?.quote, ...block.css?.[blockType] }}
              className="border-l-4 border-gray-300 pl-4 italic text-gray-600"
            >
              {getElementValue(block, "text") || block?.value}
            </blockquote>
          );
        case "button":
          const handleClick = () => {
            window.open(
              getElementValue(block, "url"),
              "_blank",
              "noopener,noreferrer"
            );
          };
          return (
            <Button
              variant="contained"
              style={{ ...defaultCss?.button, ...block.css?.[blockType] }}
              onClick={handleClick}
            >
              {getElementValue(block, "text") || block?.display_name}
            </Button>
          );
        case "image":
          let urls = getElementValue(block, "files") || [];
          if (!urls.length) {
            const values = Array.isArray(block?.value)
              ? block.value
              : [block?.value];
            urls = values.filter(Boolean).map((url) => ({ url }));
          }
          return (
            <ImageCarousel
              images={urls}
              caption={getElementValue(block, "caption")}
              css={{ ...defaultCss?.image, ...block.css?.[blockType] }}
            />
          );
        case "form":
          return (
            <div
              style={{ ...defaultCss?.form, ...block.css?.[blockType] }}
              className="space-y-4"
            >
              <p className="font-bold">
                {getElementValue(block, "title") || "Form"}
              </p>
              {(getElementValue(block, "fields") || []).map((field, i) => (
                <TextField
                  key={i}
                  label={field.label}
                  name={field.name}
                  type={field.field_type || "text"}
                  defaultValue={field.default_value || field.value}
                  placeholder={field.placeholder}
                  required={field.required || false}
                  fullWidth
                  margin="normal"
                  className="bg-white"
                />
              ))}
              <Button
                variant="contained"
                className="bg-blue-500 hover:bg-blue-700 text-white"
              >
                {getElementValue(block, "submitText") || "Submit"}
              </Button>
            </div>
          );
        case "map":
          const lat = Number(getElementValue(block, "lat"));
          const lng = Number(getElementValue(block, "lng"));
          if (lat && lng) {
            return (
              <MapBlockComponent
                lat={lat}
                lng={lng}
                css={{ ...defaultCss?.map, ...block.css?.[blockType] }}
              />
            );
          }
          return null;
        case "table":
          return (
            <div style={{ overflow: "auto", width: "200px" }}>
              <table
                style={{ ...defaultCss?.table, ...block.css?.[blockType] }}
                className="border-collapse"
              >
                <thead style={{ overflow: "auto", width: "200px" }}>
                  <tr>
                    {(getElementValue(block, "headers") || []).map(
                      (header, i) => (
                        <th
                          key={i}
                          className="border border-gray-300 p-2 bg-gray-100"
                        >
                          {header}
                        </th>
                      )
                    )}
                  </tr>
                </thead>
                <tbody style={{ overflow: "auto", width: "200px" }}>
                  {(getElementValue(block, "rows") || []).map((row, i) => (
                    <tr key={i}>
                      {row.map((cell, j) => (
                        <td key={j} className="border border-gray-300 p-2">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        case "faq":
          return (
            <div
              style={{ ...defaultCss?.faq, ...block.css?.[blockType] }}
              className="space-y-2"
            >
              {(getElementValue(block, "items") || []).map((faqItem, i) => (
                <details key={i} className="bg-white p-3 rounded-lg shadow">
                  <summary className="font-semibold cursor-pointer">
                    {faqItem.question}
                  </summary>
                  <p className="text-gray-700 mt-2">{faqItem.answer}</p>
                </details>
              ))}
            </div>
          );
        case "section":
          const children = block.children || [];
          return (
            <div style={{ ...block?.mergedCss }} className="space-y-4">
              {/* <div style={{ ...defaultCss?.section, ...block.css?.section, ...outerCss }} className="space-y-4"> */}
              {children.map((child, i) => (
                <div key={child.id || i} className="card-block w-full">
                  {renderBlock(child)}
                </div>
              ))}
              {/* </div> */}
            </div>
          );
        default:
          return null;
      }
    };

    return (
      <div
        style={{
          display: "flex",
          flexDirection: isColumnLayout ? "column" : "row",
          gap: "8px",
        }}
      >
        {displayName && block.add_display_name ? (
          isColumnLayout ? (
            <div style={{ width: "100%", ...outerCss }}>
              <div
                style={{
                  ...defaultCss?.displayNameContainer,
                  ...block.css?.displayNameContainer,
                }}
              >
                <Typography
                  variant="subtitle1"
                  style={{
                    padding: 0,
                    margin: 0,
                    ...defaultCss?.displayName,
                    ...block.css?.displayName,
                  }}
                  className="font-bold text-gray-800"
                >
                  {displayName}
                </Typography>
              </div>
              {blockContent()}
            </div>
          ) : (
            <div
              className="flex flex-row items-center justify-start gap-1"
              style={{ width: "100%", ...outerCss }}
            >
              <div
                style={{
                  ...defaultCss?.displayNameContainer,
                  ...block.css?.displayNameContainer,
                }}
              >
                <Typography
                  variant="subtitle1"
                  style={{
                    padding: 0,
                    marginBlockEnd: 0,
                    ...defaultCss?.displayName,
                    ...block.css?.displayName,
                  }}
                  className="font-bold text-gray-800 flex-shrink-0"
                >
                  {displayName}:
                </Typography>
              </div>
              {blockContent()}
            </div>
          )
        ) : (
          <div style={{ width: "100%", ...outerCss }}>{blockContent()}</div>
        )}
      </div>
    );
  };

  return (
    <div className="card-preview-container" style={cardStyle}>
      {blocks?.map((block) => (
        <>
          {block?.isMerged ? (
            <>
              {console.log("blockblock", block)}
              <div key={block.id} className="card-block w-full relative">
                {renderBlock(block)}
              </div>
            </>
          ) : (
            <div key={block.id} className="card-block w-full relative">
              {renderBlock(block)}
            </div>
          )}
        </>
      ))}
    </div>
  );
});

// Utility to convert CSS object to inline styles
const cssToStyle = (css) => {
  return Object.entries(css).reduce((acc, [key, value]) => {
    const kebabKey = key.replace(/([A-Z])/g, "-$1").toLowerCase();
    acc[kebabKey] = value;
    return acc;
  }, {});
};

export const ItineraryWidget = ({ blocks, onPlaceClick }) => {
  console.log("🚀 ~ ItineraryWidget ~ blocks:", blocks);
  // const { blocks } = schema.data;

  // List of common capitalized words that are not place names (stop words)
  const stopWords = [
    "Spend",
    "Arrive",
    "Take",
    "Visit",
    "In",
    "Fly",
    "The",
    "And",
    "A",
    "An",
    "To",
    "Of",
    "For",
    "On",
    "At",
    "With",
    "By",
    "From",
    "Into",
    "During",
    "Including",
    "Before",
    "After",
    "Above",
    "Below",
    "Between",
    "Under",
    "Over",
    "Through",
    "Day",
    "Evening",
    "Afternoon",
    "Morning",
    "Night",
    "Thailand",
    "Thai",
    "Ayutthaya",
    "Phuket",
    "Chiang",
    "Mai",
    "Switzerland",
    "Swiss",
    "Zurich",
    "Lucerne",
    "Interlaken",
    "Bern",
  ];

  // Function to dynamically identify place names in text
  const identifyPlaces = (text) => {
    console.log("🚀 ~ identifyPlaces ~ text:", text);

    const placeRegex = /\b([A-Z][a-z]+(?:\s[A-Z][a-z]+)*)\b/g;
    const matches = text ? [...(text?.matchAll(placeRegex) || "")] : [];
    const places = matches
      .map((match) => match[0])
      .filter((place) => !stopWords.includes(place));
    return places;
  };

  // Function to split text and wrap place names in clickable spans
  // const renderTextWithPlaces = (text) => {
  //   const places = identifyPlaces(text);
  //   if (places.length === 0) return text;

  //   const placePattern = places
  //     .map((place) => place.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"))
  //     .join("|");
  //   const regex = new RegExp(`(${placePattern})`, "g");
  //   const parts = text.split(regex);

  //   return parts.map((part, i) => {
  //     const isPlace = places.includes(part);
  //     return isPlace ? (
  //       <span
  //         key={i}
  //         className="itinerary-place"
  //         onClick={() => {
  //           if(onPlaceClick){
  //             onPlaceClick(part)
  //           }
  //         }}
  //       >
  //         {part}
  //       </span>
  //     ) : (
  //       part
  //     );
  //   });
  // };
  const renderTextWithPlaces = (text) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");

    const traverse = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent;
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.tagName.toLowerCase() === "place") {
          const placeName = node.textContent;
          return (
            <span
              key={placeName + Math.random()}
              className="itinerary-place"
              onClick={() => {
                if (onPlaceClick) {
                  onPlaceClick(placeName);
                }
              }}
            >
              {placeName}
            </span>
          );
        }

        // Preserve other tags (like <b>, <i>, etc.)
        const Tag = node.tagName.toLowerCase();
        return (
          <Tag key={Math.random()}>
            {Array.from(node.childNodes).map((child, idx) => (
              <React.Fragment key={idx}>{traverse(child)}</React.Fragment>
            ))}
          </Tag>
        );
      }
      return null;
    };

    return Array.from(doc.body.childNodes).map((node, idx) => (
      <React.Fragment key={idx}>{traverse(node)}</React.Fragment>
    ));
  };

  // Group blocks into days
  const days = [];
  let currentDay = null;

  blocks.forEach((block) => {
    if (block.type === "header") {
      currentDay = {
        header: block,
        image: null,
        activities: [],
      };
      days.push(currentDay);
    } else if (currentDay) {
      if (block.type === "image") {
        currentDay.image = block;
      } else if (block.type === "paragraph") {
        currentDay.activities.push(block);
      }
    }
  });
  console.log("🚀 ~ ItineraryWidget ~ days:", days);
  return (
    <>
      <ErrorBoundary>
        <div
          style={{
            margin: "16px",
            backgroundColor: "#f9fafb",
            borderRadius: "8px",
          }}
        >
          <style>
            {`
          .itinerary-day {
            margin-bottom: 16px;
          }
          .itinerary-day-label {
            margin-bottom: 8px;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
          }
          .itinerary-content {
            display: flex;
            align-items: flex-start;
          }
          .itinerary-image-section {
            flex-shrink: 0;
          }
          .itinerary-image-container {
            width: 96px;
            height: 96px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            overflow: hidden;
          }
          .itinerary-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .itinerary-activities {
            flex: 1;
            align-self: center;
          }
          .itinerary-activities ul {
            list-style-type: disc;
            list-style-position: outside;
            margin: 0;
            padding-left: 20px;
            color: #1f2937;
          }
          .itinerary-activities li {
            margin-bottom: 4px;
            line-height: 1.625;
          }
          .itinerary-place {
            color: #2563eb;
            text-decoration: underline;
            cursor: pointer;
          }
          .itinerary-place:hover {
            color: #1e40af;
          }
        `}
          </style>

          {days.map((day, index) => {
            const headerStyle = cssToStyle(day.header.css.header);
            const imageStyle = day.image ? cssToStyle(day.image.css.image) : {};

            return (
              <div key={index} className="itinerary-day">
                {/* Header spanning full width */}
                <div style={headerStyle} className="itinerary-day-label">
                  {
                    day.header.data.elements.find((el) => el.field === "text")
                      ?.value
                  }
                </div>

                {/* Image and Activities in a flex row below the header */}
                <div className="itinerary-content">
                  {/* Image Section */}
                  <div className="itinerary-image-section">
                    <div className="itinerary-image-container">
                      {day.image ? (
                        <img
                          style={imageStyle}
                          src={
                            day.image.data.elements.find(
                              (el) => el.field === "files"
                            )?.value?.[0]?.url || null
                          }
                          alt={day.image.display_name}
                          className="itinerary-image"
                        />
                      ) : (
                        <span style={{ color: "#6b7280" }}>No Image</span>
                      )}
                    </div>
                  </div>

                  {/* Activities Section */}
                  <div
                    style={{ marginLeft: "16px" }}
                    className="itinerary-activities"
                  >
                    <ul>
                      {day.activities.map((activity, idx) => {
                        const paragraphStyle = cssToStyle(
                          activity.css.paragraph
                        );
                        const text = activity.data.elements.find(
                          (el) => el.field === "text"
                        )?.value;

                        return (
                          <li
                            key={idx}
                            style={paragraphStyle}
                            // dangerouslySetInnerHTML={{__html:renderTextWithPlaces(text)}}
                          >
                            {renderTextWithPlaces(text)}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </ErrorBoundary>
    </>
  );
};
